export default {
  loadingDataOnPageLoad: null,
  items: [],
  recommendationsRequestId: null
};
